<template>
    <div class="feedback-form">
        <form novalidate>
          <div class="form-group">
              <label for="input-1">{{ $t('Email') }}:</label>
              <input required ref="email" type="email" v-model="email" class="form-control" id="input-1" placeholder="your@email.com" @keydown.enter="$event.preventDefault()" @keyup.enter="onEmailEnter">
              <div ref="emailFeedback" class="control-feedback"></div>
          </div>
          <div class="form-group">
              <label for="input-2">{{ $t('Message') }}:</label>
              <textarea required ref="message" maxlength="1000" v-model="message" :placeholder="$t('MessagePlaceholder')" class="form-control" id="input-2" rows="3"></textarea>
              <div ref="messageFeedback" class="control-feedback">{{ $t('MessageFeedback') }}</div>
          </div>
          <div class="form-group position-relative">
              <div ref="menu" class="dropdown-menu overflow-auto" style="max-height: 300px">
                <slot name="menuItems"></slot>
              </div>
              <button class="mr-1 btn btn-primary" @click="onSubmit" :disabled="submitBtnAnimating">
              <span v-if="!submitBtnAnimating">{{ $t('Send') }}</span>
              <div v-if="submitBtnAnimating" class="spinner-border spinner-border-sm"></div>
              </button>
          </div>
        </form>
        <slot name="result"></slot>
    </div>
</template>

<script>
export default {   
  props: ['submitBtnAnimating'],
  data() {
    return {email: '', message: ''};
  },
  i18n: {
    messages: {
      en: {
        "MessagePlaceholder": "Message text ...",
        "MessageFeedback": "Message must not be empty",
      },
      ru: {
        "MessagePlaceholder": "Текст сообщения ...",
        "MessageFeedback": "Сообщение не должно быть пустым"
      }
    }
  },
  methods: {
    reset(evt) {
      if (evt) { evt.preventDefault(); }
      this.email = '';
      this.message = '';
    },
    onEmailEnter() {
      if (this.validateEmail()) { 
        this.$refs.message.focus();
      }
    },
    validateEmail() {
      const validity = this.$refs.email.validity;
      if (!validity.valid) {
        if (validity.valueMissing) {
          this.$refs.emailFeedback.innerHTML = this.$t('InputSomething', [this.$t('Email').toLowerCase()]) + ', ' + this.$t('Please').toLowerCase();
        } else {
          this.$refs.emailFeedback.innerHTML = this.$t('FIRAuthErrorCodeInvalidEmail');
        }
      }
      this.$refs.emailFeedback.classList.toggle("invalid", !validity.valid);
      this.$refs.email.classList.toggle("invalid", !validity.valid);
      return validity.valid;
    },
    validateForm() {
      const emailValid = this.validateEmail();
      const messageValid = this.$refs.message.validity.valid;
      this.$refs.message.classList.toggle('invalid', !messageValid);
      this.$refs.messageFeedback.classList.toggle('invalid', !messageValid);
      return emailValid && messageValid;
    },
    onSubmit(event) {
      event.preventDefault();
      if (this.validateForm()) {
        this.$emit('submit', event, this.email, this.message);
      }
    },
    showMenu() {
      this.$refs.menu.classList.add("show");
    },
    hideMenu() {
      this.$refs.menu.classList.remove("show");
    }
  }
}
</script>